import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { usePromoExpiryPoll } from "hooks/usePromoExpiryPoll";
import { bindMember, setGameIframeModal, showMessage } from "redux/AppAction";
import { AlertTypes, WebUrl } from "util/Constant";

/**
 * App-level: uses Redux isActivedPromoExist. One mount covers all pages + in-game.
 */
export default function PromoExpiryPoll() {
	const { t } = useTranslation();
	const _dispatch = useDispatch();
	const _history = useHistory();
	const heartBeat = useSelector((state) => state.authState.heartBeat);
	const isActivedPromoExist = useSelector(
		(state) => state.appState.walletsDetails?.isActivedPromoExist
	);
	const promoExpiresAt = useSelector(
		(state) => state.appState.walletsDetails?.promoExpiresAt
	);

	const onForfeited = useCallback(async () => {
		_dispatch(setGameIframeModal(false));
		try {
			await bindMember(_dispatch);
		} catch (e) {
			/* wallet refresh best-effort */
		}
		_dispatch(
			showMessage({
				type: AlertTypes._WARNING,
				title: t("PROMO_EXPOIRED"),
				content: t("PROMO_FORFEITED_ON_EXPIRY"),
				onConfirm: () => {
					_history.push(WebUrl._URL_HOME);
				},
			})
		);
		_history.push(WebUrl._URL_HOME);
	}, [_dispatch, _history, t]);

	usePromoExpiryPoll({
		enabled: Boolean(heartBeat && isActivedPromoExist),
		expiresAt: promoExpiresAt,
		onForfeited,
	});

	return null;
}
